/**
 * Formata uma data de forma segura, retornando string vazia se a data for inválida
 * @param dateString - String da data a ser formatada
 * @returns String formatada da data ou string vazia se inválida
 */
export const formatDateSafely = (dateString: string | undefined | null): string => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Verifica se a data é válida
  if (isNaN(date.getTime())) {
    return '';
  }
  
  return date.toLocaleDateString('pt-BR');
};

/**
 * Formata uma data e hora de forma segura
 * @param dateString - String da data a ser formatada
 * @returns String formatada da data e hora ou string vazia se inválida
 */
export const formatDateTimeSafely = (dateString: string | undefined | null): string => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Verifica se a data é válida
  if (isNaN(date.getTime())) {
    return '';
  }
  
  return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Formata datas no formato brasileiro (dd/MM/yyyy HH:mm:ss) que vêm do backend
 * @param dateString - String da data no formato brasileiro
 * @returns String formatada da data ou mensagem de erro se inválida
 */
export const formatBrazilianDate = (dateString: string | undefined | null): string => {
  if (!dateString) return 'Data não disponível';
  
  // Verifica se a data está no formato brasileiro (dd/MM/yyyy HH:mm:ss)
  const brazilianDateRegex = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/;
  const match = dateString.match(brazilianDateRegex);
  
  if (match) {
    const [, day, month, year, hour, minute, second] = match;
    // Cria uma data válida no formato ISO
    const isoDate = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    const date = new Date(isoDate);
    
    if (isNaN(date.getTime())) {
      return 'Data inválida';
    }
    
    return date.toLocaleDateString('pt-BR');
  }
  
  // Se não estiver no formato esperado, tenta criar uma data padrão
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Data não disponível';
  }
  
  return date.toLocaleDateString('pt-BR');
}; 